import SectionHeading from "./SectionHeading";
import { partnerLogos } from "@/mocks/content";

export default function SocialProof() {
  return (
    <section id="prova" className="bg-background-100 py-24 md:py-32">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionHeading
          eyebrow="Resultados e prova social"
          title="Restaurantes que já despertam desejo."
          subtitle="Em breve, histórias reais de quem transformou o cardápio em experiência. Seu negócio pode ser o próximo."
        />

        {/* Faixa de logos de restaurantes parceiros */}
        <div className="reveal mt-16 rounded-2xl border border-background-200 bg-background-50 px-6 py-12 text-center md:px-10">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-primary-100 text-primary-600">
            <i className="ri-store-2-line text-2xl" aria-hidden="true" />
          </span>
          <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">
            Logos de restaurantes parceiros
          </h3>
          <p className="mx-auto mt-2 max-w-md text-sm leading-relaxed text-foreground-600">
            Restaurantes, redes e franquias que já usam a PlayMenu para dar água
            na boca.
          </p>

          <ul className="mt-10 flex flex-wrap items-center justify-center gap-6 md:gap-10">
            {partnerLogos.map((logo, index) => (
              <li
                key={logo.name}
                className="reveal flex flex-col items-center gap-3"
                style={{ transitionDelay: `${index * 90}ms` }}
              >
                <span className="flex h-24 w-24 items-center justify-center rounded-full border border-background-200 bg-background-50 p-3 md:h-32 md:w-32 md:p-4">
                  <img
                    src={logo.image}
                    alt={`Logo de ${logo.name}, restaurante parceiro PlayMenu`}
                    title={`${logo.name} · restaurante parceiro PlayMenu`}
                    className="h-full w-full object-contain"
                  />
                </span>
                <span className="text-sm font-semibold text-foreground-800">
                  {logo.name}
                </span>
              </li>
            ))}
          </ul>
        </div>

        {/* Depoimentos (preparados para casos reais) */}
        <div className="mt-6 grid gap-6 md:grid-cols-3">
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              className="reveal rounded-2xl border border-dashed border-background-300 bg-background-50 p-7"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-background-200 text-foreground-400">
                <i className="ri-chat-quote-line text-xl" aria-hidden="true" />
              </span>
              <p className="mt-4 text-sm leading-relaxed text-foreground-500">
                Depoimento em breve — espaço reservado para histórias reais de
                donos de restaurante.
              </p>
              <div className="mt-5 flex items-center gap-3 border-t border-background-200 pt-5">
                <span className="h-10 w-10 rounded-full bg-background-200" />
                <div>
                  <p className="text-sm font-bold text-foreground-800">Nome do cliente</p>
                  <p className="text-xs text-foreground-500">Restaurante · Cidade</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Números reais (preparados) */}
        <div className="reveal mt-6 rounded-2xl border border-dashed border-background-300 bg-background-50 p-10 text-center">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-primary-100 text-primary-600">
            <i className="ri-line-chart-line text-2xl" aria-hidden="true" />
          </span>
          <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">
            Números reais, em breve
          </h3>
          <p className="mx-auto mt-2 max-w-md text-sm leading-relaxed text-foreground-600">
            Não inventamos estatísticas. Quando tivermos resultados reais dos
            restaurantes que usam a PlayMenu, eles aparecem aqui.
          </p>
        </div>
      </div>
    </section>
  );
}